import { enUS, es, et, ru } from "date-fns/locale";
import { registerLocale } from "react-datepicker";

const withMondayWeekStart = (locale: typeof enUS) => ({
    ...locale,
    options: {
        ...locale.options,
        weekStartsOn: 1 as const,
    },
});

const localeMap = {
    ru: withMondayWeekStart(ru),
    en: withMondayWeekStart(enUS),
    es: withMondayWeekStart(es),
    et: withMondayWeekStart(et),
};

registerLocale("ru", localeMap.ru);
registerLocale("en", localeMap.en);
registerLocale("es", localeMap.es);
registerLocale("et", localeMap.et);

export const resolveDatepickerLocale = (language: string): keyof typeof localeMap => {
    const normalizedLanguage = (language || "en").split("-")[0].toLowerCase();

    return normalizedLanguage in localeMap ? (normalizedLanguage as keyof typeof localeMap) : "en";
};

export const formatDateValue = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const formatDateTimeValue = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const parseDateValue = (value: string): Date | null => {
    if (!value) {
        return null;
    }

    const [year, month, day] = value.split("-").map(Number);
    if (!year || !month || !day) {
        return null;
    }

    return new Date(year, month - 1, day);
};

export const parseDateTimeValue = (value: string): Date | null => {
    if (!value) {
        return null;
    }

    const [datePart, timePart = "00:00"] = value.split("T");
    const [year, month, day] = datePart.split("-").map(Number);
    const [hours, minutes] = timePart.split(":").map(Number);

    if (!year || !month || !day || Number.isNaN(hours) || Number.isNaN(minutes)) {
        return null;
    }

    return new Date(year, month - 1, day, hours, minutes);
};
